const analyticsScriptUrl = process.env.REACT_APP_UMAMI_SCRIPT_URL;
const analyticsWebsiteId = process.env.REACT_APP_UMAMI_WEBSITE_ID;

export function loadAnalytics() {
    if (!analyticsScriptUrl || !analyticsWebsiteId || typeof document === 'undefined') {
        return false;
    }
    if (document.querySelector('script[data-umami-website-id]')) {
        return true;
    }
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = analyticsScriptUrl;
    script.dataset.websiteId = analyticsWebsiteId;
    script.dataset.umamiWebsiteId = analyticsWebsiteId;
    script.setAttribute('data-do-not-track', 'true');
    script.onerror = () => {};
    document.head.appendChild(script);
    return true;
}
